import { ProductStockLocation } from "@shared_packages/toolkit/types";
import { ColumnDef } from "@tanstack/react-table";
import { FC, useMemo } from "react";
import styled from "styled-components";
import { ReactTableComponent } from "../../../../components/ui-kit";

const StyledReactTableComponent = styled(ReactTableComponent)`
  thead {
    tr {
      th {
        padding: 15px 10px;
      }
    }
  }
`;

interface LocationTableProps {
  stockLocations: ProductStockLocation[];
  isTrackableWatch?: boolean;
}

export const InventoryLocationTable: FC<LocationTableProps> = ({
  stockLocations,
  isTrackableWatch = false,
}) => {
  const columns: Array<ColumnDef<ProductStockLocation, any>> = useMemo(
    () => [
      {
        header: "Location",
        accessorKey: "location",
        cell: ({ row: { original } }) => (
          <div style={{ minWidth: 210 }}>
            {original.location?.name ?? original.location}
          </div>
        ),
      },
      {
        header: "Alley",
        accessorKey: "alley",
        cell: ({ row: { original } }) => {
          return original.alley;
        },
      },
      {
        header: "Shelf",
        accessorKey: "shelf",
        cell: ({ row: { original } }) => {
          return original.shelf;
        },
      },
      {
        header: "Quantity",
        accessorKey: "qty",
        cell: ({ row: { original } }) => {
          return original.qty;
        },
      },
      {
        header: "Low stock level",
        accessorKey: "lowStockLevel",
        cell: ({ row: { original } }) => {
          return original.statusSettings?.low ?? 0;
        },
      },
      {
        header: "High stock level",
        accessorKey: "highStockLevel",
        cell: ({ row: { original } }) => {
          return original.statusSettings?.high;
        },
      },
    ],
    []
  );

  return (
    <StyledReactTableComponent
      data={stockLocations}
      columnVisibility={{
        lowStockLevel: isTrackableWatch,
        highStockLevel: isTrackableWatch,
      }}
      columns={columns}
      padding={"10px"}
    />
  );
};
